import React from 'react';

import { HStack, Skeleton } from '@rbilabs/universal-components';

export const OfferStatusContainerSkeleton = () => {
  return (
    <HStack>
      <Skeleton width="3/4" height="$3" rounded={12} marginBottom="$1" />
    </HStack>
  );
};
